module.exports = __webpack_public_path__ + "media/6.0c12fbef.mp3";